import React from "react";
import { Tabs, Tab } from "material-ui/Tabs";

const LIST_CATEGORIES = [
  { name: "title", value: "title" },
  { name: "opening text", value: "opening" },
  { value: "closing", name: "closing text" },
  { value: "format", name: "format" },
];

const TemplatesMenuCategories = ({
  onActive,
  category,
}) => (
  <div className="wrap-menu-categories">
    <div className="custom-tab">
      <Tabs
        inkBarStyle={{ background: "#6da92e" }}
        value={category}
        onChange={onActive}
        tabItemContainerStyle={{ backgroundColor: "#fff", width: "500px" }}
      >
        {LIST_CATEGORIES.map(({ name, value }) => (
          <Tab
            key={value}
            style={{ textTransform: "uppercase", color: "rgba(0, 0, 0, 0.6)" }}
            value={value}
            label={name}
          />
        ))}
      </Tabs>
    </div>
  </div>
);

export default TemplatesMenuCategories;
